import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import p404 from '@/components/common/errors/p404'

// layouts
import SportsLayout from '@/components/layout/SportsLayout'
// pages
import StaticContentPage from '@/components/pages/StaticContentPage'
import SportsPage from '@/components/pages/SportsPage'
import LiveSportsPage from '@/components/pages/LiveSportsPage'
import EventPage from '@/components/pages/EventPage'
import SetDebugLevel from '@/components/common/SetDebugLevel'
import ForceSelectionsToBetslip from '@/components/sports/bettingoffer/forceSelectionsToBetslip'
import setOpenedFromWebViewPage from '@/components/pages/setOpenedFromWebViewPage'

Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta' // the attribute name vue-meta adds to the tags it observes
})
Vue.use(Router)

const router = new Router({
  // uncomment to turn on routes with no hash
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/sports'
  }, {
    path: '/home',
    name: 'home',
    redirect: '/sports'
  }, {
    path: '',
    name: 'sports-layout',
    component: SportsLayout,
    children: [
      {
        path: '/sports',
        name: 'sports',
        component: SportsPage,
        props: true
      },
      {
        path: '/sports/navigation/:idfwbonavigation1',
        name: 'bonavigation1',
        component: SportsPage,
        props: true
      },
      {
        path: '/sports/navigation/:idfwbonavigation1/:idfwbonavigation2',
        name: 'bonavigation2',
        component: SportsPage,
        props: true
      },
      {
        path: '/sports/navigation/:idfwbonavigation1/:idfwbonavigation2/:idfwbonavigation3',
        name: 'bonavigation3',
        component: SportsPage,
        props: true
      },
      {
        path: '/sports/event/:idfoevent',
        name: 'event',
        component: EventPage,
        props: true
      },
      {
        path: '/sports/injectselections/:idfoselectionscsv',
        name: 'event',
        component: ForceSelectionsToBetslip,
        props: true
      },
      {
        path: '/live',
        name: 'sports-live',
        component: LiveSportsPage,
        props: true
      }
    ]
  },
  {
    path: '/info/:infopagename',
    name: 'info',
    component: StaticContentPage,
    props: true
  },
  {
    path: '/setdebug/:level',
    name: 'setDebug',
    component: SetDebugLevel,
    props: true
  },
  {
    path: '/404',
    name: 'page-not-found',
    component: p404
  }, {
    path: '/fromwebview',
    name: 'setOpenedFromWebView',
    component: setOpenedFromWebViewPage
  }, {
    path: '*',
    redirect: '/404'
  }],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js